const fractionToNumber = (fraction) => {
  // convert fractions to numerical value for comparison
  if (fraction) {
    const [numerator, denominator] = fraction.split("/").map(Number);
    return numerator / denominator;
  }
  return 0;
};

const bothLabelNumeric = (order, labelA, labelB) => {
  // Both labels are numeric
  if (order === "desc") {
    return Number(labelB) - Number(labelA);
  } else {
    return Number(labelA) - Number(labelB);
  }
};

const bothLabelFraction = (order, labelA, labelB) => {
  // Both labels are fractions
  if (order === "desc") {
    return fractionToNumber(labelB) - fractionToNumber(labelA);
  } else {
    return fractionToNumber(labelA) - fractionToNumber(labelB);
  }
};

const compareNumberWithFraction = (order, labelA, labelB) => {
  // Compare number with fraction
  if (order === "desc") {
    return fractionToNumber(labelB) - Number(labelA);
  } else {
    return Number(labelA) - fractionToNumber(labelB);
  }
};

const compareFractionWithNumber = (order, labelA, labelB) => {
  // Compare fraction with number
  if (order === "desc") {
    return Number(labelB) - fractionToNumber(labelA);
  } else {
    return fractionToNumber(labelA) - Number(labelB);
  }
};

const compareForOtherString = (order, labelA, labelB) => {
  // Lexicographic comparison for other strings
  if (order === "desc") {
    if (labelA > labelB) return -1;
    if (labelA < labelB) return 1;
    return 0;
  } else {
    if (labelA < labelB) return -1;
    if (labelA > labelB) return 1;
    return 0;
  }
};

export const sortArrayOfObjects = (array, column, order = "asc") => {
  // Helper function to determine if a label is a number or fraction
  const isNumeric = (label) => !isNaN(label);
  const isFraction = (label) => label.includes("/");

  return array.sort((a, b) => {
    const labelA = a[column];
    const labelB = b[column];

    const aIsNumeric = isNumeric(labelA);
    const bIsNumeric = isNumeric(labelB);

    const aIsFraction = isFraction(labelA);
    const bIsFraction = isFraction(labelB);

    if (aIsNumeric && bIsNumeric) {
      return bothLabelNumeric(order, labelA, labelB);
    } else if (aIsFraction && bIsFraction) {
      return bothLabelFraction(order, labelA, labelB);
    } else if (aIsNumeric && bIsFraction) {
      return compareNumberWithFraction(order, labelA, labelB);
    } else if (aIsFraction && bIsNumeric) {
      return compareFractionWithNumber(order, labelA, labelB);
    } else {
      return compareForOtherString(order, labelA, labelB);
    }
  });
};

export const getSortedFilters = (currentFilters, filterOptArr) => {
  const current = [];
  const options = sortArrayOfObjects(
    filterOptArr?.filter((a) => a?.attribute_code !== "category_uid"),
    "label",
  );

  const updateAppliedArr = (optArr, parent) => {
    optArr.forEach((op) => {
      if (op.value === parent.value) {
        current.push({ ...parent, count: op.count });
      }
    });
  };

  currentFilters.forEach((i) => {
    options.forEach((item) => {
      if (item.attribute_code === i.code) {
        updateAppliedArr(item.options, i);
      }
    });
  });
  return { options, current };
};

export const getSelectedFilters = (optionsList, filterOpts = []) => {
  const selectedArr = filterOpts;
  try {
    const sParams = new URL(window.location.href).searchParams;
    const mainOptions = sortArrayOfObjects(optionsList, "label");

    let params = {};
    for (const [key, val] of sParams.entries()) {
      params[key?.toLowerCase()] = val?.toLowerCase();
    }

    mainOptions.forEach((f) => {
      const labelKey = f.label.toLowerCase();
      const hasCode = params.hasOwnProperty(f.attribute_code);
      const hasLabel = params.hasOwnProperty(labelKey);

      if (hasCode || hasLabel) {
        let filterArr = [];
        if (hasCode) {
          filterArr = params[f.attribute_code].split(",");
        } else if (hasLabel) {
          filterArr = params[labelKey].split(",");
        }

        f.options.forEach((o) => {
          let hasVal = filterArr.includes(o.value);
          if (hasLabel && !hasVal) {
            hasVal = filterArr.includes(o.label.toLowerCase());
          }

          if (hasVal) {
            selectedArr.push({
              ...o,
              filter_label: f.label,
              code: f.attribute_code,
            });
          }
        });
      }
    });
  } catch (err) {
    console.error(err);
  }
  return selectedArr;
};

export const getSortedKeys = (inputObj) => {
  const keys = Object.keys(inputObj);
  const alphaKeys = keys.filter((key) => /^[A-Za-z]+$/.test(key));
  const numberKeys = keys.filter((key) => /^\d+$/.test(key));
  return [...alphaKeys, ...numberKeys];
};

export const replaceArray = (string, findArr, replaceArr) => {
  let res = string;
  if (Array.isArray(findArr) && Array.isArray(replaceArr)) {
    for (let i = 0; i < findArr.length; i++) {
      res = res?.replace(findArr[i], replaceArr[i]);
    }
  }
  return res;
};

export const hasParentWithMatchingSelector = (target, selector) => {
  return [...document.querySelectorAll(selector)].some(
    (el) => el !== target && el.contains(target),
  );
};
